module.exports = __webpack_public_path__ + "images/onboarding/christy_kondo.jpg";